import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Radio,
	RadioGroup,
	Stack,
	styled,
	Typography,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { DeckContext } from '../../context/DeckContext';
import { DeckContext as DeckContextV3 } from '../../context/DeckContextV3';
import { Block } from 'src/types/shared/blocksV3';
import useIsBetaCanvasEnabled from 'src/hooks/useBetaCanvas';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

type ModalProps = {
	neededDropbeams: number;
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	block: Block;
};

const StyledLabel = styled(Typography)({
	fontWeight: 500,
	fontSize: 14,
});

const DropbeamNeededModal: React.FC<ModalProps> = ({
	neededDropbeams,
	open,
	setOpen,
	block,
}) => {
	const isBetaEnabled = useIsBetaCanvasEnabled();

	const { state, dispatch } = isBetaEnabled
		? useContext(DeckContextV3)
		: useContext(DeckContext);

	const [plies, setPlies] = useState(2);

	return (
		<Dialog
			open={open}
			onClose={(e) => {
				e.preventDefault();
			}}
		>
			<DialogTitle>
				<Typography variant="h2" fontWeight="bold">
					<InfoOutlineIcon /> Drop beam needed
				</Typography>
			</DialogTitle>

			<DialogContent>
				<Stack>
					<Typography
						color="black"
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							fontSize: '14px',
						}}
					>
						Your joist span is too long for the current material and spacing.
						Please choose a drop beam to continue.
					</Typography>

					<RadioGroup
						value={plies}
						onChange={(e) => setPlies(parseInt(e.target.value))}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'start',
								marginTop: '30px',
							}}
						>
							<FormControlLabel
								value={2}
								control={<Radio />}
								label={<StyledLabel>Double</StyledLabel>}
							/>
							<FormControlLabel
								value={3}
								control={<Radio />}
								label={<StyledLabel>Triple</StyledLabel>}
							/>
						</Box>
					</RadioGroup>
				</Stack>
			</DialogContent>

			<DialogActions
				sx={{
					borderTop: '1px solid #8484854D',
				}}
			>
				<>
					<Button
						onClick={() => {
							dispatch({
								type: 'UPDATE_BLOCK',
								payload: {
									...block,
									dropbeam: {
										isIncluded: true,
										numberOfBoards: plies,
										quantity: neededDropbeams,
									},
								},
							});

							if (state.displayedBlockModal?.id == block.id) {
								dispatch({
									type: 'OPEN_BLOCK_MODAL',
									payload: {
										...block,
										dropbeam: {
											isIncluded: true,
											numberOfBoards: plies,
											quantity: neededDropbeams,
										},
									},
								});
							}

							setOpen(false);
						}}
						variant="contained"
						color="primary"
						sx={{ fontWeight: 'bold' }}
					>
						Include Dropbeam
					</Button>
				</>
			</DialogActions>
		</Dialog>
	);
};

export default DropbeamNeededModal;
